module.exports = __webpack_public_path__ + "img/8.62f99403.png";